export var breakpointTypes = ['xl', 'l', 'm', 's', 'xs'];